import React from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

export const bodyStyles: React.CSSProperties = {
  width: '100%',
  marginTop: '10px'
};

export const firstRowOptionsStyles: React.CSSProperties = {
  display: 'flex'
};

export const columnsDropdownWrapperStyles: React.CSSProperties = {
  marginBottom: '10px',
  width: '100%'
};

export const columnsAutocompleteStyles: SxProps<Theme> = {
  minHeight: '36px',
  '& .MuiOutlinedInput-root': {
    padding: '0px',
    minHeight: '36px',
    border: '.5px solid #D9D9D9',
    borderRadius: '4px',
    '&:hover': {
      borderColor: '#D9D9D9'
    },
    '&.Mui-focused': {
      borderColor: '#D9D9D9'
    },
    '& fieldset': {
      border: 'none'
    }
  },
  '& .MuiAutocomplete-listbox': {
    fontFamily: 'Circular Std Book !important'
  },
  '& .MuiInputBase-input': {
    fontSize: '14px'
  }
};

export const columnsAutocompleteLiStyles: React.CSSProperties = {
  fontFamily: 'Circular Std Book',
  fontSize: '12px',
  color: '#777777',
  fontWeight: 450
};

export const columnsAutocompletePlaceholderStyles: SxProps<Theme> = {
  '& .MuiInputBase-input::placeholder': {
    fontSize: '14px',
    fontFamily: 'Circular Std Book',
    color: '#777777',
    fontWeight: 450
  }
};

export const childWrapperStyles: React.CSSProperties = {
  display: 'flex',
  marginBottom: '10px'
};

export const columnNameInputStyles: React.CSSProperties = {
  width: '250px',
  height: '36px',
  border: '.5px solid #D9D9D9',
  borderRadius: '4px',
  color: '#000',
  fontSize: '14px',
  fontWeight: '450',
  fontFamily: 'Circular Std Book',
  paddingLeft: '10px',
  outline: 'none'
};

export const columnNameMarginStyles: React.CSSProperties = {
  marginLeft: '20px'
};

// export const scrollBlockStyles: React.CSSProperties = {
//   maxHeight: '150px',
//   overflowY: 'auto',
//   overflowX: 'hidden',
//   marginBottom: '10px'
// };
